
















































view_model =
  components:
    listItem: require('./list_item.vue')
    destroyModal: require('./destroy_modal.vue')
    companiesAutocomplete: require('../shared/autocomplete/companies')

  data: ->
    users: []
    loading: false
    company_name: Session.current_company.name,
    destroy_user: {}
    current_user: Session.current_user
    company_id: Session.current_company.id
    company: Session.current_company
    company_options: []
    companies: []
    next_page: 1
    text_field_filter: ''
    attrs: {
      placeholder: "Digite o nome da empresa"
    }

  computed:
    max_number_of_regular_users: ->
      if @company && @company.account_setting && !(@company.account_setting instanceof Array)
        @company.account_setting.max_number_of_regular_users
      else
        '-'

    max_number_of_monitoring_managers: ->
      if @company && @company.account_setting && !(@company.account_setting instanceof Array)
        @company.account_setting.max_number_of_monitoring_managers
      else
        '-'

  methods:
    invitation: ->
      return if @isInvitationDisabled()
      @$router.push path: "/configuracoes/usuarios/convidar"

    isInvitationDisabled: ->
      if @company && @company.account_setting
        @company.number_of_regular_users >= @max_number_of_regular_users && @company.number_of_monitoring_managers >= @max_number_of_monitoring_managers
      else
        false

    loadUsersSuccess: (data) ->
      @loading = false
      @users = @users.concat(data.users)
      @next_page = data.meta.next_page

    currentUser: ->
      Session.current_user

    userUpdated: (user) ->
      @users.replaceById(user)

    showDestroyModal: (user) ->
      @destroy_user = user
      jQuery('#destroy-user-modal').modal('show')

    loadCompany: ->
      new CompaniesResource().get(@loadCompanySuccess, @loadCompaniesError, { id: @company_id } )

    loadCompanySuccess: (data) ->
      @company = data.company
      Loader.off()

    loadCompanies: ->
      new CompaniesResource().index(@loadCompaniesSuccess, @loadCompaniesError, params: { limit: '5' })

    loadCompaniesSuccess: (data) ->
      @loading = false
      @companies = data.companies
      @company_options = []
      for company in data.companies
        @company_options.push(company.name)
      Loader.off()

    loadUsers: ->
      return if @loading || !@next_page
      params = { q: {accepted: false, search_query: @text_field_filter}, page: @next_page, limit: '15' }
      params['company_id'] = @company_id if @current_user.isAdmin()
      @loading = true
      new UsersResource().index(@loadUsersSuccess, null, {params})

    userDestroyed: (user) ->
      @users.remove(user.id)
      if user.role == 'monitoring_manager'
        @company.number_of_monitoring_managers = @company.number_of_monitoring_managers - 1
      else
        @company.number_of_regular_users = @company.number_of_regular_users - 1

    selectedCompany: (company) ->
      if @companies.length > 0
        @company = @companies.find (c) -> c.name == company
        @company_id = @company.id if @company

    searchCompanies: (search) ->
      return if @loading || search.length < 3
      @loading = true
      params = { q: { search_query: search }, limit: '5' }
      new CompaniesResource().index(@loadCompaniesSuccess, @loadCompaniesError, {params})

    loadCompaniesError: ->
      @loading = false

  watch:
    company_id: ->
      @users = []
      @next_page = 1
      @loadUsers()

  created: ->
    Loader.on()
    @loadUsers()
    @loadCompany()
    @loadCompanies() if @current_user.isAdmin()

exports.default = view_model




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/users/index.vue